var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('input-textarea',{attrs:{"text":_vm.workFloNoteLocal.note},on:{"update:text":function($event){return _vm.$set(_vm.workFloNoteLocal, "note", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }